import { Body, Flex, Heading, Sheet, useDisclosure } from '@hover/blueprint';
import React from 'react';
import { Trans } from 'react-i18next';

import { PROJECT_DETAILS_PADDING } from 'src/modules/homeownerApp/components/Projects/Project/ProjectCardSection';
import { ScanDetails } from 'src/modules/homeownerApp/components/Scan/ScanDetails';
import type { BasicJobInfoFragment } from 'src/shared/graphql/generated';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { hideScrollbarsStyles } from 'src/shared/utils/styles';

type MeasurementHeaderProps = {
  scan: BasicJobInfoFragment;
  projectId: number;
};

export const MeasurementHeader = ({
  scan,
  projectId,
}: MeasurementHeaderProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <>
      <Flex
        data-testid="project-measurement-header"
        direction="column"
        pb={600}
        px={PROJECT_DETAILS_PADDING}
      >
        <Heading m={0} textStyle="heading100">
          {t('projects.keyMeasurements.header.header')}
        </Heading>
        <Body color="neutral.500" m={0} textStyle="body300">
          <Trans
            components={{
              Link: (
                <Body
                  color="neutral.500"
                  colorScheme="neutral"
                  cursor="pointer"
                  display="inline"
                  m={0}
                  onClick={onOpen}
                  textDecoration="underline"
                  textStyle="body300"
                />
              ),
            }}
            i18nKey="projects.keyMeasurements.header.basedOnHoverScan"
            t={t}
          />
        </Body>
      </Flex>
      <Sheet
        contentProps={{
          width: { base: '100%', tablet: 'auto' },
          maxWidth: { base: '100%', tablet: '888px' },
          paddingRight: '0 !important',
          paddingLeft: '0 !important',
          paddingTop: '0 !important',
          paddingBottom: '0 !important',
          height: '100%',
          overflowY: 'auto',
          sx: { ...hideScrollbarsStyles(), borderRadius: 0 },
        }}
        isClosable={false}
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        size={{ base: 'full', tablet: 'auto' }}
        variant="modal"
      >
        <ScanDetails onClose={onClose} projectId={projectId} scan={scan} />
      </Sheet>
    </>
  );
};
